// src/utils/html.js

/**
 * Strips HTML tags from a string and collapses whitespace.
 * @param {string} html The HTML string to clean.
 * @returns {string} The cleaned text.
 */
export function stripHtmlToText(html) {
  if (!html) {
    return '';
  }
  // Use regex to remove HTML tags and collapse whitespace
  return html.replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim();
}
